import type {JSONContent} from '@tiptap/core';
import type {AvailableVariable} from '../../../config/nodeVariables';
import type {EmailPlaceholder} from '../../../config/emailPlaceholders';
import {automationVariableToken} from '../../../config/variableReferences';

export type AutomationVariableOption =
    | {kind: 'reference'; variable: AvailableVariable}
    | {kind: 'placeholder'; placeholder: EmailPlaceholder};

export const referenceOptions = (variables: AvailableVariable[]): AutomationVariableOption[] =>
    variables.map(variable => ({kind: 'reference', variable}));

export const automationOptionToken = (option: AutomationVariableOption): string => option.kind === 'placeholder'
    ? `[[${option.placeholder.key}]]`
    : automationVariableToken({nodeName: option.variable.nodeName ?? '', name: option.variable.name});

export const automationOptionContent = (option: AutomationVariableOption): JSONContent => option.kind === 'placeholder'
    ? {type: 'automationPlaceholder', attrs: {key: option.placeholder.key}}
    : {type: 'automationVariable', attrs: {nodeName: option.variable.nodeName, name: option.variable.name}};

export const filterAutomationOptions = (options: AutomationVariableOption[], query: string) => {
    const needle = query.trim().toLowerCase();
    return options.filter(option => {
        const terms = option.kind === 'placeholder'
            ? [option.placeholder.key, option.placeholder.value]
            : [option.variable.name, option.variable.nodeName, option.variable.description];
        return terms.some(term => term?.toLowerCase().includes(needle));
    });
};
